const fr = {
  // Header
  nav_home: 'Accueil',
  nav_booking: 'Réserver',
  nav_therapists: 'Thérapeutes',
  menu_label: 'Menu',

  // Hero
  hero_badge: 'Premium Thai Massage',
  hero_title: 'Découvrez le meilleur\nmassage thaïlandais',
  hero_subtitle: 'Réservez un massage premium avec des thérapeutes professionnels à Pattaya, Phuket, Bangkok et Korat',
  hero_book_now: 'Réserver maintenant',
  hero_view_therapists: 'Voir les thérapeutes',
  stat_therapists: 'Thérapeutes experts',
  stat_locations: 'Emplacements',
  stat_rating: 'Note moyenne',

  // Features
  feature_gps_title: 'Détection GPS auto',
  feature_gps_desc: 'Trouve automatiquement la zone la plus proche de votre position',
  feature_booking_title: 'Réservation facile',
  feature_booking_desc: 'Réservez un massage facilement en seulement 5 étapes',
  feature_verified_title: 'Thérapeutes vérifiés',
  feature_verified_desc: 'Thérapeutes professionnels vérifiés par leur expérience et avis',

  // Nearby therapists section
  nearby_title: 'Thérapeutes près de vous',
  nearby_subtitle: 'Thérapeutes recommandés selon votre position GPS',
  nearby_loading: 'Détection de votre position...',
  nearby_error: 'Impossible de détecter votre position',
  nearby_retry: 'Réessayer',
  nearby_distance: 'À {distance} km',
  nearby_book: 'Réserver',

  // Locations section
  section_locations_title: 'Zones disponibles',
  section_locations_subtitle: 'Nous offrons nos services dans 5 grandes villes de Thaïlande',
  loc_book: 'Réserver',

  // Courses section
  section_courses_title: 'Cours de massage',
  section_courses_subtitle: 'Découvrez nos différents programmes de massage',

  // Therapists section
  section_therapists_title: 'Thérapeutes populaires',
  section_therapists_subtitle: 'Découvrez nos thérapeutes les mieux notés',
  view_all_therapists: 'Voir tous les thérapeutes',

  // CTA
  cta_title: 'Réservez maintenant',
  cta_subtitle: 'La meilleure expérience de massage thaï vous attend',
  cta_book: 'Réserver',

  // Footer
  footer_copyright: '© 2026 Thai Massage Booking. Tous droits réservés.',

  // Booking Steps
  step_location: 'Zone',
  step_course: 'Cours',
  step_therapist: 'Thérapeute',
  step_datetime: 'Date/Heure',
  step_confirm: 'Confirmation',

  // Booking - Step 1
  booking_location_title: 'Sélectionnez une zone',
  booking_location_desc: 'Choisissez la zone où vous souhaitez votre massage',
  gps_detect: 'Détecter ma position',
  gps_loading: 'Détection en cours...',

  // Booking - Step 2
  booking_course_title: 'Sélectionnez un cours de massage',
  booking_course_desc: 'Choisissez votre type de massage et la durée souhaitée',
  duration_min: '{min} min',

  // Booking - Step 3
  booking_therapist_title: 'Sélectionnez un thérapeute',
  booking_therapist_desc: 'Thérapeutes disponibles à {location}',
  no_therapist: 'Aucun thérapeute disponible pour la zone et le cours sélectionnés.',
  no_therapist_suggest: 'Veuillez essayer un autre cours.',

  // Booking - Step 4
  booking_datetime_title: 'Sélectionnez la date et l\'heure',
  booking_datetime_desc: 'Choisissez votre date et heure préférées',
  date_select: 'Choisir la date',
  time_select: 'Choisir l\'heure',
  time_placeholder: 'Veuillez d\'abord sélectionner une date',
  time_notice: 'L\'arrivée du thérapeute peut prendre jusqu\'à 2 heures selon la distance. Veuillez choisir un horaire avec suffisamment de marge.',

  // Booking - Step 5
  booking_confirm_title: 'Confirmez votre réservation',
  booking_confirm_desc: 'Vérifiez toutes les informations et entrez vos coordonnées',
  summary_location: 'Zone',
  summary_course: 'Cours',
  summary_price: 'Prix',
  summary_therapist: 'Thérapeute',
  summary_date: 'Date',
  summary_time: 'Heure',
  health_check_title: 'État de santé',
  health_check_desc: 'Veuillez nous informer de tout problème de santé, douleur ou zone à éviter pendant le massage.',
  health_check_placeholder: 'Ex : J\'ai de l\'hypertension / Mon épaule droite est blessée, soyez doux sur le haut du corps / Évitez le bas du dos à cause d\'une hernie discale',
  health_check_examples: 'Ex : J\'ai de l\'hypertension / Mon épaule droite est blessée, soyez doux sur le haut du corps / Évitez le bas du dos à cause d\'une hernie discale',
  contact_title: 'Coordonnées',
  contact_name: 'Nom',
  contact_name_placeholder: 'Entrez votre nom',
  contact_phone: 'Téléphone',
  contact_phone_placeholder: 'Entrez votre numéro de téléphone',
  contact_email: 'E-mail',
  contact_email_placeholder: 'Entrez votre adresse e-mail',
  contact_note: 'Demandes spéciales',
  contact_note_placeholder: 'Entrez vos demandes spéciales',
  required_mark: '*',

  // Navigation buttons
  btn_prev: 'Retour',
  btn_next: 'Suivant',
  btn_complete: 'Confirmer la réservation',

  // Therapist card
  age_suffix: ' ans',
  experience_years: '{years} ans d\'exp.',

  // Therapist list page
  tl_title: 'Thérapeutes',
  tl_subtitle: 'Rencontrez nos meilleurs thérapeutes vérifiés par leur expérience et expertise',
  tab_all: 'Tous',

  // Confirmation page
  conf_empty_title: 'Aucune information de réservation',
  conf_empty_desc: 'Veuillez effectuer une réservation depuis la page de réservation.',
  conf_empty_btn: 'Réserver',
  conf_success_title: 'Réservation confirmée !',
  conf_success_subtitle: 'Votre réservation a été confirmée. Merci.',
  conf_preparation_title: 'Réservation non reçue',
  conf_preparation_subtitle: 'Notre service est en cours de préparation, votre réservation n\'est donc pas encore confirmée. Nous vous contacterons dès l\'ouverture officielle.',
  conf_preparation_notice: 'Le service est en cours de préparation — cette réservation n\'est pas une réservation confirmée.',
  conf_booking_id: 'N° de réservation',
  conf_detail_title: 'Détails de la réservation',
  conf_label_location: 'Zone',
  conf_label_course: 'Cours de massage',
  conf_label_price: 'Prix',
  conf_label_therapist: 'Thérapeute',
  conf_label_date: 'Date',
  conf_label_time: 'Heure',
  conf_label_email: 'E-mail',
  conf_label_contact: 'Contact',
  conf_label_note: 'Demandes spéciales',
  conf_notice_title: 'Avis important',
  conf_notice_1: 'L\'arrivée du thérapeute peut prendre jusqu\'à 2 heures selon la distance.',
  conf_notice_2: 'Veuillez nous contacter par téléphone pour modifier ou annuler votre réservation.',
  conf_notice_3: 'Le paiement peut être effectué sur place en espèces ou par carte.',
  conf_btn_home: 'Accueil',
  conf_btn_new: 'Nouvelle réservation',

  // Geolocation errors
  GEO_NOT_SUPPORTED: 'Votre navigateur ne supporte pas le GPS.',
  GEO_PERMISSION_DENIED: 'L\'accès à la localisation a été refusé. Veuillez sélectionner une zone manuellement.',
  GEO_POSITION_UNAVAILABLE: 'Les informations de localisation ne sont pas disponibles.',
  GEO_TIMEOUT: 'La demande de localisation a expiré.',
  GEO_UNKNOWN: 'Une erreur inconnue s\'est produite.',

  // SEO
  seo_home_title: 'Massage à Domicile en Thaïlande | Bangkok In Home Massage',
  seo_home_desc: 'Thérapeutes certifiés à votre hôtel ou hébergement à Bangkok, Pattaya, Phuket, Chiang Mai et Korat. Massage thaï, aromathérapie et huile. Réservez en ligne facilement.',
  seo_therapists_title: 'Thérapeutes Massage à Domicile | Bangkok In Home Massage',
  seo_therapists_desc: 'Découvrez nos thérapeutes certifiés à Bangkok, Pattaya, Phuket, Chiang Mai et Korat. Consultez profils, avis et spécialités, puis réservez en ligne.',
  seo_booking_title: 'Réserver un Massage à Domicile | Bangkok In Home Massage',
  seo_booking_desc: 'Choisissez votre lieu, type de massage et thérapeute pour réserver un massage à domicile. Nos thérapeutes se déplacent à votre hôtel ou hébergement.',

  // Body info
  height_label: 'Taille',
  weight_label: 'Poids',

  // GPS therapist list
  gps_find_nearby: 'Trouver les thérapeutes proches',
  gps_nearby_active: 'Trié par proximité',

  // Notices
  notice_punctual: 'Le thérapeute viendra à la date et l\'heure réservées. Veuillez être prêt à l\'heure.',
  notice_no_sexual: 'Ceci est un service de massage professionnel. Les services à caractère sexuel sont strictement interdits.',

  // Guide section
  guide_title: 'Guide d\'utilisation',
  guide_subtitle: 'Veuillez lire les informations suivantes pour une expérience confortable',
  guide_before_title: 'Avant la séance',
  guide_before_text: 'Une douche légère avant la séance est recommandée. Veuillez éviter de réserver juste après un repas. Le service peut être refusé en état d\'ébriété. Si vous avez des problèmes de santé (hypertension, maladie cardiaque, etc.) ou êtes enceinte, veuillez le mentionner dans les demandes spéciales lors de la réservation.',
  guide_booking_title: 'Infos réservation',
  guide_booking_text: 'L\'arrivée du thérapeute peut prendre jusqu\'à 2 heures selon la distance. Veuillez choisir un horaire avec suffisamment de marge. Pour modifier ou annuler votre réservation, veuillez nous contacter par téléphone.',
  guide_session_title: 'Pendant la séance',
  guide_session_text: 'Le thérapeute se rendra à votre hébergement à l\'heure réservée. Si vous ressentez un inconfort pendant la séance, veuillez en informer immédiatement le thérapeute. Ceci est un service de massage professionnel. Les services à caractère sexuel sont strictement interdits.',
  guide_after_title: 'Après la séance',
  guide_after_text: 'Veuillez boire beaucoup d\'eau. Des courbatures ou une fatigue temporaires sont normales et disparaîtront en 2-3 jours. Veuillez éviter la consommation excessive d\'alcool et l\'exercice intense le jour de la séance.',
  guide_payment_title: 'Paiement',
  guide_payment_text: 'Le paiement peut être effectué sur place en espèces ou par carte.',

  // FAQ
  faq_q1: 'Comment fonctionne le massage à domicile ?',
  faq_a1: 'Sélectionnez votre zone, choisissez un type de massage, un thérapeute, puis réservez une date et une heure. Le thérapeute se rendra à votre hôtel ou hébergement.',
  faq_q2: 'Dans quelles zones proposez-vous vos services ?',
  faq_a2: 'Nous proposons des services de massage à domicile professionnels à Bangkok, Pattaya, Phuket, Chiang Mai et Korat.',
  faq_q3: 'Comment modifier ou annuler ma réservation ?',
  faq_a3: 'Veuillez nous contacter par téléphone pour modifier ou annuler votre réservation. Le paiement peut être effectué sur place en espèces ou par carte.',

  // 404
  notfound_title: 'Page introuvable',
  notfound_desc: 'La page demandée n\'existe pas ou a été déplacée.',
  notfound_home: 'Retour à l\'accueil',
};

export default fr;
